import React, { useEffect, useState } from "react";
import { Form, Modal } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import "./Login_Modal.css";
import { faEye, faEyeSlash, faXmark } from "@fortawesome/free-solid-svg-icons";
import PasswordChecklist from "react-password-checklist";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Reset_Password_Modal from "../reset_password_modal/Reset_Password_Modal";
import Black_Btn from "../../common_btn/black_btn/Black_Btn";
import "react-phone-input-2/lib/style.css";
import PhoneInput from "react-phone-input-2";
import Success_Modal from "../success_modal/Success_Modal";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  sendMobileOtpLogin,
  sendMobileOtpSingUp,
  UserLogin,
  userSignUp,
  verifyOtp,
  verifyOtpLogin,
} from "../../../../features/auth/authSlice";
import { getAllCart } from "../../../../features/cart/cartSlice";
import { myAccount } from "../../../../features/my_account/Slice";
import { text } from "@fortawesome/fontawesome-svg-core";
import SingUp_Modal from "./Singup_Modal";
import OtpInput from "react-otp-input";

const Login_Modal = (props) => {
  const {
    control,
    register,
    handleSubmit,
    setError,
    watch,
    clearErrors,
    reset,
    formState: { errors },
  } = useForm();

  const [showSuccessModal, setShowSucsessModal] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");

  const navigate = useNavigate();

  const [showSignUp, setShowSignUp] = useState(false);
  const [password, setPassword] = useState("");
  const [passwordAgain, setPasswordAgain] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordOne, setShowPasswordOne] = useState(false);
  const [iconOne, setIconOne] = useState(faEyeSlash);
  const [iconTwo, setIconTwo] = useState(faEyeSlash);

  const togglePasswordVisibility = (field) => {
    if (field === "password") {
      setShowPassword(!showPassword);
      setIconOne(showPassword ? faEyeSlash : faEye);
    } else if (field === "reenterPassword") {
      setShowPasswordOne(!showPasswordOne);
      setIconTwo(showPasswordOne ? faEyeSlash : faEye);
    }
  };

  const dispatch = useDispatch();
  const isSignin = useSelector((state) => state.auth.is_signin);

  //loginnn-------------------
  const onLogin = async (data) => {
    const res = await dispatch(UserLogin(data));

    if (res.meta?.requestStatus === "fulfilled") {
      props?.onHide();
      props?.loginDone();
      setSuccessMsg("Login Succesfully !");
      setShowSucsessModal(true);
      setTimeout(() => {
        setShowSucsessModal(false);
        // navigate("/")
      }, 3000);
      dispatch(getAllCart(isSignin));
    } else if (res.meta?.requestStatus === "rejected") {
      if (res.payload?.errors?.email) {
        setError("email", {
          type: "manual",
          message: res.payload?.errors?.email,
        });
      }
      if (res.payload?.errors?.password) {
        setError("password", {
          type: "manual",
          message: res.payload?.errors?.password,
        });
      }
    }
  };

  const user = useSelector((state) => state.myaccount.addMyaccount);

  useEffect(() => {
    if (user?.id) {
      dispatch(myAccount());
    }
  }, []);

  const [otp, setOtp] = useState("");
  const [mobileNoError, setMobileNoError] = useState("");
  const [showmobOtp, setShowmobOtp] = useState(false);
  const [otpError, setOtpError] = useState("");
  const mobileNo = watch("contact_no");
  const [timer, setTimer] = useState(0);

  const sendOtp = async (e) => {
    e.preventDefault();

    setOtp("");
    setOtpError("");

    if (!mobileNo) {
      setError("contact_no", {
        type: "manual",
        message: "Please Enter Contact No",
      });
      return;
    }
    if (!mobileNo || mobileNo?.length < 10) {
      setError("contact_no", {
        type: "manual",
        message: "Please Enter valid Contact No",
      });

      return;
    }
    setMobileNoError("");
    clearErrors("");
    setOtpError("");
    try {
      const data = { contact_no: mobileNo };
      const res = await dispatch(sendMobileOtpLogin(data));

      if (res.meta?.requestStatus === "fulfilled") {
        // handleNext();
        setShowmobOtp(true);
        setTimer(60);
      } else if (res.meta?.requestStatus === "rejected") {

        setError("contact_no", {
          type: "manual",
          message: res.payload?.errors,
        });
        // setMobileNoError(res.payload?.errors);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleGetmobOtp = (e) => {
    e.preventDefault();
    // setMobileNoError("");
    sendOtp();
  };

  const [verifyStatus, setVerifyStatus] = useState(false);
  const [selectedCode, setSelectedCode] = useState(null);
  const handleVerifyOtp = async () => {
    if (!otp) {
      setOtpError("Provide Four Digit OTP");
      return;
    }
    try {
      const data = { contact_no: mobileNo, otp };
      const res = await dispatch(verifyOtpLogin(data));

      if (res.meta?.requestStatus === "fulfilled") {
        setVerifyStatus(true);
        setShowmobOtp(false);
        setMobileNoError("");
        setOtpError("");

        props?.onHide();
        props?.loginDone();
        setSuccessMsg("Login Succesfully !");
        setShowSucsessModal(true);
        setTimeout(() => {
          setShowSucsessModal(false);
          // navigate("/")
        }, 3000);
        setOtp("");
        reset("");
        dispatch(getAllCart(isSignin));
      } else if (res.meta?.requestStatus === "rejected") {
        setOtpError(
          res.payload?.errors || "An error occurred. Please try again.",
        );
      }
    } catch (error) {
      console.error("Error verifying OTP:", error);
      setOtpError("An unexpected error occurred. Please try again.");
    }
  };

  useEffect(() => {
    let interval = null;
    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [timer]);

  const resetModalState = () => {
    reset({
      contact_no: "",
    });

    clearErrors();

    setOtp("");
    setOtpError("");
    setMobileNoError("");
    setShowmobOtp(false);
    setVerifyStatus(false);
    setTimer(0);

    setPassword("");
    setPasswordAgain("");

    setShowPassword(false);
    setShowPasswordOne(false);

    setIconOne(faEyeSlash);
    setIconTwo(faEyeSlash);
  };

  useEffect(() => {
    if (props.show) {
      resetModalState();
    }
  }, [props.show]);

  const handleClose = () => {
    resetModalState();
    props?.onHide();
  };


  return (
    <>
      <Modal className="Login_Modal" size="md" {...props} centered>
        <div className="absolute_div">
          <div className="logo_holder">
            <img src="/assets/images/login/logo.png" className="logo_img" />
          </div>
        </div>

        {/* <div className="close_div"
          onClick={() => {
            props?.onHide();
          }}
        >
          <FontAwesomeIcon icon={faXmark} className="close_icon" />
        </div> */}

        <div
          className="close_div"
          onClick={handleClose}
        >
          <FontAwesomeIcon icon={faXmark} className="close_icon" />
        </div>

        <Modal.Body>
          {/* <div className="close_img_div">
            <img
              src="/assets/images/login/close.png"
              className="close_img"
              onClick={() => {
                props?.onHide();
              }}
            />
          </div> */}

          {!showSignUp && (
            <div className="login_div">
              <div className="login_form_div">
                <Form>
                  <Form.Group className="gray_input_group input_group">
                    <Form.Label>Contact No</Form.Label>
                    <Form.Control
                      placeholder="Enter Contact Number"
                      aria-label="Contact"
                      aria-describedby="basic-addon1"
                      type="text"
                      readOnly={showmobOtp}
                      // readOnly={verifyStatus}
                      maxLength={selectedCode?.length || 10} // 👈 fallback 10
                      {...register("contact_no", {
                        required: "Contact number is required",
                      })}
                      onKeyPress={(e) => {
                        if (!/[0-9]/.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />

                    {/* <div className="otpbtnholder">
                      {verifyStatus ? (
                        <p className="verify">Verify</p>
                      ) : (
                        <>
                          {!showmobOtp && (
                            <button className="sendotp" onClick={sendOtp}>
                              Send OTP
                            </button>
                          )}

                          {timer === 0 && showmobOtp && (
                            <button className="sendotp" onClick={sendOtp}>
                              Resend OTP
                            </button>
                          )}
                        </>
                      )}
                    </div> */}
                    {errors?.contact_no && (
                      <div style={{ fontSize: "13px", color: "red" }}>
                        {errors?.contact_no?.message}
                      </div>
                    )}

                    {mobileNoError && (
                      <div className="text-cenetr">
                        <span className="text-danger">{mobileNoError}</span>
                      </div>
                    )}
                  </Form.Group>

                  {/* <Form.Group className="gray_input_group input_group">
                    <Form.Label>Password</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Password"
                      {...register("password", {
                        required: "Password is required",
                      })}
                    />
                    {errors.password && (
                      <div style={{ fontSize: "13px", color: "red" }}>
                        {errors.password.message}
                      </div>
                    )}
                    <p
                      className="link_text dark_text"
                      onClick={() => {
                        props?.onHide();
                        props?.setShowResetModal();
                      }}
                    >
                      Forgot Password?
                    </p>
                  </Form.Group> */}
                </Form>
              </div>

              {showmobOtp && timer > 0 && (
                <div className="otp_inputes mb-3">
                  <OtpInput
                    value={otp}
                    onChange={(value) => {
                      const numericValue = value.replace(/[^0-9]/g, "");
                      setOtp(numericValue);
                    }}
                    numInputs={4}
                    inputType="tel"
                    renderSeparator={<span>-</span>}
                    renderInput={(props) => (
                      <input
                        {...props}
                        onKeyPress={(e) => {
                          if (!/[0-9]/.test(e.key)) {
                            e.preventDefault();
                          }
                        }}
                      />
                    )}
                  />
                  {/* <OtpInput
                    value={otp}
                    onChange={setOtp}
                    numInputs={4}
                    renderSeparator={<span>-</span>}
                    renderInput={(props) => <input {...props} />}
                  /> */}

                  {timer > 0 && (
                    <div className="timer_holder">
                      <p> Resend OTP {timer} Secends</p>
                    </div>
                  )}
                </div>
              )}
              <div className=" text-center ">
                {otpError && <span className="text-danger">{otpError}</span>}
              </div>
              <div className="d-md-flex gap-3 align-items-center mt-4">
                {showmobOtp && timer > 0 ? (
                  <div className="btn_holder text-center ">
                    <Black_Btn
                      btnText="Login"
                      onClick={handleSubmit(handleVerifyOtp)}
                    />
                  </div>
                ) : (
                  <div className="btn_holder text-center ">
                    <Black_Btn btnText="Send OTP" onClick={sendOtp} />
                  </div>
                )}

                {/* <p className="dark_text">
                  Don't have an account?{" "}
                  <span
                    className="link_text"
                    onClick={() => {
                      setShowSignUp(true);
                    }}
                  >
                    Create Account
                  </span>
                  .
                </p> */}
              </div>

              {/* <div className='or_text_div'>
                                <p className='or_txt'>Or</p>
                            </div>

                            <div className='google_img_holder'>
                                <div className='img_holder'>
                                    <img src='/assets/images/login/google.png' className='g_img' />
                                </div>
                                <p className='signu_with_g_txt'>Sign Up with Google</p>
                            </div> */}
            </div>
          )}

          {showSignUp && (
            <SingUp_Modal
              setShowSignUp={setShowSignUp}
              showSignUp={showSignUp}
              setShowAccountCreted={props?.setShowAccountCreted}
              onHide={props?.onHide}
            />
          )}
        </Modal.Body>
      </Modal>

      <Success_Modal
        show={showSuccessModal}
        onHide={() => {
          setShowSucsessModal(false);
        }}
        successText={successMsg}
      />
    </>
  );
};

export default Login_Modal;
